module.exports = __webpack_public_path__ + "assets/img/discernvcode_close_btn@2x.a0fbb3ec.png";